import { useMutation } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";

const addFiles = (postData) => {
  return http().post(endpoints.quotes.postUploadFile, postData);
};

export function usePostFileUpload() {
  return useMutation(addFiles, {
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
